import React from "react";
import RLogo from "../assets/recruitmentslogo.png";

function LoadingScreen() {
  return (
    <div
      style={{ backgroundColor: "#78c0ab" }}
      className="align-middle justify-center justify-items-center flex h-screen"
    >
      <img
        alt="logo"
        src={RLogo}
        className="animate-pulse align-middle w-48 justify-center m-auto "
      />
    </div>
  );
}

export default LoadingScreen;
